const variables = {
  'border-radius': 24,
  'border-radius-button': 999,
  'border-radius-round': 999,
  gap: 24,
  'primary-button-disabled-opacity': 1,
  'primary-button-font-size': 16,
  'secondary-button-border-width': 0,
  'secondary-button-disabled-opacity': 1,
  'secondary-button-font-size': 16,
} as const;

export default variables;
